import { Components, createTheme, SimplePaletteColorOptions } from '@mui/material/styles';

import { APPBAR_EXT_HEIGHT } from '../constants/layout';
import breakpoints from './breakpoints';
import components from './components';
import palette from './palette';
import typography from './typography';
import shadows from './shadows';

declare module '@mui/material/styles' {
  interface Palette {
    internal: Palette['primary'];
    neutral: Palette['primary'];
  }

  interface PaletteOptions {
    internal?: SimplePaletteColorOptions;
    neutral?: SimplePaletteColorOptions;
  }

  interface TypeBackground {
    default: string;
    primary: string;
    internal: string;
    internalDark: string;
    grayTransparent: string;
    success: string;
    warning: string;
    error: string;
    preProd: string;
    info: string;
    white: string;
    darkGray: string;
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      ...breakpoints,
    },
  },
  palette,
  typography: typography,
  mixins: {
    toolbar: {
      minHeight: APPBAR_EXT_HEIGHT.xs,
      [`@media (min-width: ${breakpoints.md}px)`]: {
        minHeight: APPBAR_EXT_HEIGHT.md,
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: shadows,
  // TODO: fix type
  components: components as Components,
});

export default theme;
